import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';

const TopModes = () => {
    const { state } = useContext(SmartContext);
    const modes = state.data.topModes;

    return (
        <div className="bg-white p-4 custom-shadow h-100 radius-6">
            <h5 className="col font-18 font-600 mb-3">Top Modes</h5>
            {modes.length === 0 ? (
                <p className="font-14 text-gray-64">No mode data available.</p>
            ) : (
                <div className="d-flex flex-column gap-2 overflow-y-auto pe-1" style={{ maxHeight: '268px' }}>
                    {modes.map((mode: any, index: number) => (
                        <div
                            key={index}
                            className="hover-item d-flex justify-content-between align-items-center px-3 py-3 rounded-3">
                            <span className="text-dark font-500">{getDomainValueForCode(mode.name, 'OUTREACH_MODE', state)}</span>
                            <div className="d-flex align-items-center gap-2">
                                <span className="font-14 font-500 text-secondary">
                                    <i className="bi bi-clock"></i> {mode.duration}
                                </span>
                                <span
                                    className="border border-dark rounded-pill px-3 py-1 font-14 font-500 text-dark"
                                    style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                                    {mode.logs} logs
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TopModes;
